import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import { getH5AdminToken, getSchoolsActiveOrgId } from './utils/h5-admin-request'
import { getH5AdminUserCache } from './api/h5-admin-auth'
import { buildSchoolsAdminRoutes } from './pages/schools/config/admin-menus'
import { hasH5AdminMenu, H5_ADMIN_MENU_KEYS } from './pages/admin/config/admin-menus'

const router = new Router({
	routes: [
		{path: '/',redirect:'index'},
		{
			path: '/carvue',
			alias: ['/car', '/car/index.html'],
			component: () => import('./pages/carvue/CarExhibition.vue'),
			name: '车展H5'
		},
		{
			path: '/carvue/shake-detect',
			component: () => import('./pages/carvue/CarShakeDetect.vue'),
			name: '摇一摇检测'
		},
		{path: '/index',component:()=>import("./pages/index.vue"),name:"跳转"},
		{path: '/templateOne',component:()=>import("./pages/templateOne.vue"),name:"活动"},
		{path: '/activity',component:()=>import("./pages/activity.vue"),name:"活动详情"},
		{path: '/sealNav',component:()=>import("./pages/admin/sealNav.vue"),name:"印章工具", meta: { requiresH5Admin: true }},
		{path: '/sealPointsInput',component:()=>import("./pages/admin/sealPointsInput.vue"),name:"录入电子印章点位", meta: { requiresH5Admin: true }},
		{path: '/sealTest',component:()=>import("./pages/admin/sealTest.vue"),name:"印章相似度测试", meta: { requiresH5Admin: true }},
		{path: '/sealTouchDetect',component:()=>import("./pages/sealTouchDetect.vue"),name:"印章触点检测"},
		{path: '/coupons',component:()=>import("./pages/coupons.vue"),name:"券票"},
		{path: '/code',component:()=>import("./pages/code.vue"),name:"新年福利待领取"},
		// 活动跳转与模板页（与小程序同一配置双端使用，打卡坐标系一致）
		{path: '/loading/activityRedirect',component:()=>import("./pages/loading/activityRedirect.vue"),name:"活动跳转"},
		{path: '/nfc/launch',component:()=>import("./pages/loading/nfcLaunch.vue"),name:"NFC进入小程序"},
		{path: '/template/activity-multi',component:()=>import("./pages/template/activity-multi.vue"),name:"活动模板多页ACT004"},
		{path: '/activitys/birdGame',component:()=>import("./pages/activitys/birdGame/index.vue"),name:"愤怒的小鸟PK"},
		{path: '/party/screen',component:()=>import("./pages/party/screen.vue"),name:"年会大屏"},
		{ path: '/redbook/launch', component: () => import('./pages/redbook/launch.vue'), name: 'RedbookLaunch' },
		{ path: '/admin/login', component: () => import('./pages/admin/login.vue'), name: 'AdminLogin', meta: { adminGuest: true } },
		{
			path: '/admin',
			component: () => import('./pages/admin/layout.vue'),
			redirect: { name: 'AdminHome' },
			meta: { requiresH5Admin: true },
			children: [
				{
					path: 'home',
					name: 'AdminHome',
					component: () => import('./pages/admin/home.vue'),
					meta: { title: '首页', requiresH5Admin: true, affix: true, h5AdminMenu: H5_ADMIN_MENU_KEYS.HOME }
				},
				{
					path: 'redbook',
					name: 'AdminRedbook',
					component: () => import('./pages/admin/redbook/index.vue'),
					meta: { title: '小红书活动', requiresH5Admin: true, h5AdminMenu: H5_ADMIN_MENU_KEYS.REDBOOK }
				},
				...buildSchoolsAdminRoutes()
			]
		}
	]
})

function firstAllowedAdminPath(user) {
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.HOME)) return '/admin/home'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.REDBOOK)) return '/admin/redbook'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_PLATFORM_ORGS)) return '/admin/schools/platform-orgs'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_DASHBOARD)) return '/admin/schools/dashboard'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_SUBJECT)) return '/admin/schools/subject'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_COURSE)) return '/admin/schools/course'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_CLASS)) return '/admin/schools/class'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_SCHEDULE)) return '/admin/schools/schedule'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_STUDENT)) return '/admin/schools/student'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_ENROLL)) return '/admin/schools/enroll'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_ATTENDANCE)) return '/admin/schools/attendance'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_LEAVE)) return '/admin/schools/leave'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_TEACHER)) return '/admin/schools/teacher'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_ROOM)) return '/admin/schools/room'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_NOTICE)) return '/admin/schools/notice'
	if (hasH5AdminMenu(user, H5_ADMIN_MENU_KEYS.SCHOOLS_SETTING)) return '/admin/schools/setting'
	return '/admin/home'
}

router.beforeEach((to, from, next) => {
	const token = getH5AdminToken()
	if (to.name === 'AdminLogin' && token) {
		next({ path: firstAllowedAdminPath(getH5AdminUserCache()) })
		return
	}
	const needAuth = to.matched.some(record => record.meta && record.meta.requiresH5Admin)
	if (needAuth && !token) {
		next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
		return
	}
	const menuKey = to.meta && to.meta.h5AdminMenu
	if (needAuth && menuKey) {
		const user = getH5AdminUserCache()
		if (user && !hasH5AdminMenu(user, menuKey)) {
			next({ path: firstAllowedAdminPath(user) })
			return
		}
	}
	const needSchoolsOrg = to.matched.some(record => record.meta && record.meta.requiresSchoolsOrg)
	if (needAuth && needSchoolsOrg) {
		const user = getH5AdminUserCache()
		if (user && user.schoolsPlatformAdmin && !getSchoolsActiveOrgId()) {
			next({ path: '/admin/schools/platform-orgs', query: { pickOrg: '1' } })
			return
		}
	}
	const platformOnly = to.matched.some(record => record.meta && record.meta.platformAdminOnly)
	if (needAuth && platformOnly) {
		const user = getH5AdminUserCache()
		if (!user || !user.schoolsPlatformAdmin) {
			next({ path: '/admin/schools/dashboard' })
			return
		}
	}
	next()
})

export default router
